export class NoContextError extends Error {
  constructor(providerName: string) {
      super(`Cannot use the context outside the ${providerName} provider`);

      Object.setPrototypeOf(this, NoContextError.prototype);
  }
}